import React, { useEffect, useRef } from 'react';
import { useSession } from '../context/SessionContext';
import { Language } from '../types';

export const LanguageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { language, setLanguage, user, isAuthenticated, isLoading } = useSession();
  const initialSyncDone = useRef(false);

  useEffect(() => {
    // Sync context with user preference from API if authenticated
    if (!isLoading && isAuthenticated && user && !initialSyncDone.current) {
       initialSyncDone.current = true;
       if (user.language && user.language !== language) {
         setLanguage(user.language as Language);
       }
    }
  }, [user, isAuthenticated, isLoading, setLanguage, language]);

  return <>{children}</>;
};